import type { SVGProps } from 'react';

export const UsersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 2.25C17.6233 2.25 19.75 4.37664 19.75 7C19.75 8.58467 18.973 9.9867 17.7803 10.8496C20.1208 11.9093 21.75 14.2636 21.75 17C21.75 17.4142 21.4142 17.75 21 17.75C20.5858 17.75 20.25 17.4142 20.25 17C20.25 14.1005 17.8995 11.75 15 11.75C14.5546 11.75 14.1233 11.6874 13.7139 11.5723C13.552 12.9195 12.8272 14.0922 11.7803 14.8496C14.1208 15.9093 15.75 18.2636 15.75 21C15.75 21.4142 15.4142 21.75 15 21.75C14.5858 21.75 14.25 21.4142 14.25 21C14.25 18.1005 11.8995 15.75 9 15.75C6.1005 15.75 3.75 18.1005 3.75 21C3.75 21.4142 3.41421 21.75 3 21.75C2.58579 21.75 2.25 21.4142 2.25 21C2.25 18.2639 3.87862 15.9095 6.21875 14.8496C5.02639 13.9866 4.25 12.5844 4.25 11C4.25 8.37665 6.37665 6.25 9 6.25C9.44544 6.25 9.87634 6.31211 10.2852 6.42676C10.5683 4.07376 12.5707 2.25 15 2.25ZM9 7.75C7.20507 7.75 5.75 9.20507 5.75 11C5.75 12.7949 7.20508 14.25 9 14.25C10.7949 14.25 12.25 12.7949 12.25 11C12.25 9.20508 10.7949 7.75 9 7.75ZM15 3.75C13.2051 3.75 11.75 5.20508 11.75 7C11.75 7.04388 11.7522 7.08747 11.7539 7.13086C12.6876 7.79664 13.3692 8.79129 13.6309 9.94629C14.0466 10.1399 14.5096 10.25 15 10.25C16.7949 10.25 18.25 8.79492 18.25 7C18.25 5.20508 16.7949 3.75 15 3.75Z"
    />
  </svg>
);
